// Bloquear funcionalidad de clases de Ant Design para una correcta visual de los menús (cabecera, layout, móvil, etc) seleccionados
export const cleanUp = () => {
    
    var deleteClass = document.querySelector('.ant-menu-item-selected');

    if (deleteClass !== null) {
        deleteClass.classList.remove('ant-menu-item-selected')
    }
}
